import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function MetricToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class MetricForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<MetricToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.metric">
          <TextInput source="name" validate={isRequired} />
          <TextInput source="unit" validate={isRequired} />
          <TextInput source="category" validate={isRequired} />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(MetricForm);
